import React, { useRef, useState } from "react";
import HomeHero from "./HomeHero";
import FeaturedAdventures from "./FeaturedAdventures";
import VideosByRegion from "./VideosByRegion";
import WatchSectionEmbed from "./Watch";
import { useGetChannelVideosQuery } from "../features/api/youtubeApi";

export default function Home() {
  const [selectedRegion, setSelectedRegion] = useState("");
  const resultsSectionRef = useRef(null);

  // FIXED: Changed search parameter to "" so it fetches ALL videos to count every state accurately
  const { data: shortsData } = useGetChannelVideosQuery({
    search: "",
    page: 1,
    limit: 200, // FIXED: Increased limit so it reads your whole library for correct totals
    isShort: true,
  });

  const { data: videosData } = useGetChannelVideosQuery({
    search: "",
    page: 1,
    limit: 200, // FIXED: Increased limit so it reads your whole library for correct totals
    isShort: false,
  });

  const handleRegionClick = (regionName) => {
    setSelectedRegion(regionName);
    if (resultsSectionRef.current) {
      resultsSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <HomeHero />
      <FeaturedAdventures />

      {/* <VideosByRegion
        onRegionSelect={handleRegionClick}
        activeRegion={selectedRegion}
        videosData={videosData}
        shortsData={shortsData}
      /> */}

      {/* <div ref={resultsSectionRef} className="regional-results-anchor">
        <WatchSectionEmbed
          regionFilter={selectedRegion}
          onClearRegion={() => setSelectedRegion("")}
        />
      </div> */}
    </>
  );
}
